import { useState } from 'react';
import { ScreenWrapper } from '../../components';
import SetuFlow from './setuFlow';
import UploadDocumentFlow from './documentUpload';

export const IncomeProofForm = () => {
  // Setting setu flow to true by default
  const [isSetuFlow, setIsSetuFlow] = useState(true);

  const handleChangeSetuFlow = () => {
    setIsSetuFlow(!isSetuFlow);
  };

  return (
    <ScreenWrapper>
      {
        isSetuFlow ? (
          // This setu flow screen is the default screen visible to the user
          <SetuFlow handleChangeSetuFlow={handleChangeSetuFlow} />
        ) : (
          <UploadDocumentFlow handleChangeSetuFlow={handleChangeSetuFlow} />
        )
      }
    </ScreenWrapper>
  );
};

export default IncomeProofForm;
